import React from 'react';
import './myticketinfo.css'


const Myticketinfo = (props) => {
    return ( <>
        <div className='tickectinfodivv'>
            <img className='ticketinffoicon' src={props.mticon1} alt="" />
            <div className='ticketinfo6'>
                <h6 className='tinfot1'>{props.tinfo1}</h6>
                <h6 className='tinfot2'>{props.tinfo2}</h6>
            </div> 
        </div>
    </> );
}
 
export default Myticketinfo;